import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { styled } from "@mui/material/styles";

export const CustomDatePicker = styled(DatePicker)({
    width: "100%",
    "& label": {
      color: "white",
    },
    "& .MuiInputBase-root": {
      // backgroundColor: "#333333",
      color: "white",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "white",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottomColor: "#65717e",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
      },
      "&:hover fieldset": {
        borderColor: "#65717e",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#a8bbcf",
      },
    },
    "& .MuiFormHelperText-root": {
      color: "white",
    },
  });